import React from 'react';
import { Check } from 'lucide-react';
import { formatToShortDateOrNull } from '~/util/date';
import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';

const ScheduleReportDataTable = createQueryDataTable('schedule-report');
type TableProps = PropsOfQueryDataTable<typeof ScheduleReportDataTable>;

const columnDefinitions = ScheduleReportDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true,
		renderCell: row => `${row.patientName} (MR#: ${row.patientCode})`
	},
	{
		header: 'Visit Date',
		key: 'visitDate',
		sortable: true,
		filterNames: ['visitDate', 'visitDateFrom', 'visitDateTo'],
		renderCell: row => formatToShortDateOrNull(row.visitDate, '-')
	},
	{
		header: 'Assigned To',
		key: 'assignedTo',
		sortable: true,
		renderCell: row => (!row.assigned ? 'Unassigned' : row.assignedTo)
	},
	{
		header: 'Discipline',
		key: 'discipline',
		sortable: true
	},
	{
		header: 'Team',
		key: 'team',
		sortable: true
	},
	{
		header: 'Made',
		key: 'madeVisit',
		renderCell: row => (row.madeVisit ? <Check /> : null)
	},
	{
		header: 'Missed',
		key: 'missedVisit',
		renderCell: row => (row.missedVisit ? <Check /> : null)
	}
]);

export function ScheduleReportTable(props: TableProps) {
	return <ScheduleReportDataTable.Table {...props} columns={columnDefinitions} emptyMessage="No visits schedule" />;
}
